module.exports = __webpack_public_path__ + "static/img/info1.f6c3dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/info1.png
// module id = qlUw
// module chunks = 1